import { render, staticRenderFns } from "./TableCart.vue?vue&type=template&id=545e4f68"
import script from "./TableCart.vue?vue&type=script&lang=js"
export * from "./TableCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545e4f68')) {
      api.createRecord('545e4f68', component.options)
    } else {
      api.reload('545e4f68', component.options)
    }
    module.hot.accept("./TableCart.vue?vue&type=template&id=545e4f68", function () {
      api.rerender('545e4f68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/TableCart.vue"
export default component.exports